import { FAQ_LIST, type FaqItem } from "../static-config";

export async function loadFaqList(): Promise<FaqItem[]> {
	return FAQ_LIST;
}
